import RichTable from 'app/shared-components/RichTableReduxWrapper'
import useLoadDtoForSkyNetTable from 'app/shared-components/SkyNetTable/hooks/useLoadDtoForSkyNetTable'
import Card from 'app/shared-components/Card'

import requests from 'app/requests/BillingCompany.requests'
import {
    Modification,
} from './BillingCompanyChangeSummary.types'
import columns from './BillingCompanyChangeSummary.columns'
import useStyles from './BillingCompanyChangeSummary.style'

const BillingCompanyChangeSummary = ({
    id,
}: { id: number }) => {
    const {
        classes,
    } = useStyles()

    const load: (params: any) => Promise<{
        items: Modification,
        matches: number
    }> = useLoadDtoForSkyNetTable(
        requests.billingCompanyChangeSummary.request(id),
    )

    return (
        <Card
            title="Change History"
        >
            <RichTable
                configName="BillingCompanyChangeSummaryTable"
                name={requests.billingCompanyChangeSummary.name}
                load={load}
                columns={columns}
                uniqField="id"
                className={classes.tableContent}
                classNames={{
                    contentWrapper: classes.tableContentWrapper,
                }}
            />
        </Card>
    )
}

export default BillingCompanyChangeSummary
